export default "__VITE_ASSET__4c1b5bbc__"